import React from 'react'
import classNames from 'classnames'
import { Paragraph } from '@scentregroup/ui'
import { IssueSeverity } from '../../types'
import style from './index.module.scss'

export interface IIssueText {
  message: string
  severity: IssueSeverity
}

export interface IIssueTextProps {
  issue: IIssueText | null | undefined
  showIssue?: boolean
  wrapperClass?: string
}

// aria-live needs to be rendered on mount to function correctly. See the spec: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
const ConditionalIssueText: React.FunctionComponent<IIssueTextProps> = ({
  issue,
  showIssue = true,
  wrapperClass,
}) => (
  <div
    aria-live="polite"
    className={classNames(
      {
        [style.errorWrapper]: showIssue && issue,
      },
      wrapperClass
    )}
  >
    {showIssue && issue && (
      <Paragraph
        className={
          issue.severity === IssueSeverity.Error ? style.error : style.warning
        }
      >
        {issue.message}
      </Paragraph>
    )}
  </div>
)

export default ConditionalIssueText
